import React, { createRef, useState, useEffect, useContext } from "react";
import Dropzone, { ErrorCode } from "react-dropzone";

import SharedThumbImage from "../../images/upload-thumb-image.svg";
import InfoIcon from "../../images/InfoIconGray.svg";
import removeFontIcon from "../../images/remove-icon.svg";
import fontIcon from "../../images/font-icon.svg";
import addFontIcon from "../../images/AddFontIcon.svg";
import "./SharedResource.scss";
import "react-toastify/dist/ReactToastify.css";
// import WarningIcon from "../../images/warningIcon.svg"
import { uploadSharedFiles, deleteSharedFiles } from "../../services/apis";
import CustomTooltip from "../../components/Tooltip/Tooltip";
import CircularProgressBar from "../../utils/CircularProgressBar";
import Addmore from "../../images/AddPlus-Icon-White.svg";
import { showErrorToast, showSuccessToast, showWarningToast } from "../toastComponent/ToastComponent";

const SharedFontUpload = ({
  deckId,
  setAllFonts,
  deckData,
  defaultFont,
  setDefaultFont,
  setDeletedFont,
  deletedFont,
}) => {
  const dropzoneRef = createRef();
  const [filesSelected, setFileSelected] = useState([]);
  const [removeWarn, setRemoveWarn] = useState("");
  const [loading, setLoading] = useState(false);
  const fontExt = ["font/otf", "font/ttf"];

  useEffect(() => {
    setFileSelected(deckData?.deck_shared_assets?.fonts || []);
    setAllFonts(deckData?.deck_shared_assets?.fonts || []);
  }, []);

  const onFileSelection = (accepted, rejected) => {
    setLoading(true);
    // console.log(accepted, fontExt);
    const notAllowedFiles = accepted.filter(
      (file) => !fontExt.includes(file.type)
    );
    const notEligibleFiles = accepted.filter(
      (file) => fontExt.includes(file.type) && file.size > 5242880
    );
    const filterExt = accepted.filter(
      (file) => fontExt.includes(file.type) && file.size <= 5242880
    ); //
    notAllowedWarn([...notAllowedFiles, ...notEligibleFiles]);
    const formData = new FormData();
    if (filterExt.length > 10) {
      discardedExt(filterExt);
    }
    if (filterExt.length > 0) {
      filterExt.splice(0, 10).forEach((uploadFile) => {
        formData.append("fonts", uploadFile);
      });
      uploadSharedFiles(deckId, formData, (response, err, ErrorCode) => {
        if (err) {
          setLoading(false);
          toastErrorThrow([], "Upload");
        } else {
          setLoading(false);
          const data = response.data.response.allFonts;
          const failedFiles = response.data.err;
          const uploadedRecent = response.data.response.uploadedFiles;
          const fontFamilyadded = uploadedRecent.map((font) => ({
            value: font?.name?.split(".")[0],
            name: font?.name?.split(".")[0],
          }));
          setFileSelected([...data]);
          setAllFonts([...data]);
          if (defaultFont.length > 0)
            setDefaultFont([...defaultFont, ...fontFamilyadded]);
          toastSuccesThrow("Uploaded Successfully");
          if (failedFiles.length > 0) {
            toastErrorThrow(failedFiles, "Upload");
          }
        }
      });
    } else {
      setLoading(false);
    }
  };

  const handleRemove = (fileName) => {
    setRemoveWarn(fileName);
  };

  const confirmAction = (action, fileData) => {
    if (action === "NO") {
      setRemoveWarn("");
    } else {
      setLoading(true);
      const payloadObj = { list: fileData, deckId: deckId };
      deleteSharedFiles(payloadObj, (response, err, ErrorCode) => {
        if (err) {
          // console.log(err, "block err");
          setLoading(false);
          toastErrorThrow([], "Delete");
        } else {
          if (response.data.success) {
            setLoading(false);
            setDeletedFont([...deletedFont, fileData]);
            const removed = filesSelected.filter(
              (file) => file.name !== fileData.name
            );
            const filterTypo = defaultFont?.filter(
              (file) => file.name !== fileData.name?.split(".")[0]
            );
            if (defaultFont.length > 0) setDefaultFont([...filterTypo]);
            // console.log("remove font", [...deletedFont, fileData]);
            setFileSelected([...removed]);
            setAllFonts([...removed]);
            toastSuccesThrow("Deleted Successfully");
            setRemoveWarn("");
          }
        }
      });
    }
  };

  const notAllowedWarn = (files) => {
    if (files.length > 0) toastWarnThrow(files);
  };

  const discardedExt = (files) => {
    if (files.length > 0)
      showWarningToast(`${files.length - 10} files are discarded, Only 10 files are allowed at a time`);
  };

  const toastErrorThrow = (failedFiles, action) => {
    showErrorToast(`${action} Unsuccessful`, failedFiles.length > 0 && `${failedFiles.length} files failed to upload. Pl try again`);
    // toast.error(
    //   <div className="toast-text-message">
    //     <div className="toast-title error-msg">{action} Unsuccessful</div>
    //     {failedFiles.length > 0 && (
    //       <div className="toast-title-msg">
    //         {failedFiles.length} files failed to upload. Pl try again
    //       </div>
    //     )}
    //   </div>,
    //   {
    //     position: "top-right",
    //     autoClose: 5000,
    //     icon: (
    //       <img
    //         className={`toast-error-icon ${
    //           failedFiles.length > 0 ? "align-img" : ""
    //         }`}
    //         src={ErrorIcon}
    //       />
    //     ),
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: false,
    //     closeButton: (
    //       <img className="toast-success-close-icon" src={CloseIcon} />
    //     ),
    //     progress: undefined,
    //     className:
    //       "toast-popup toast-error-popup shared-toast-popup-wrong-file",
    //   }
    // );
  };

  const toastSuccesThrow = (msg) => {
    showSuccessToast(msg);
  };

  const toastWarnThrow = (files) => {
    showWarningToast('Wrong file uploaded', `${files.length} ${files.length > 1 ? "files" : "files"} are discarded
          due to wrong Extension. Pl try again`);
    // toast.warning(
    //   <div className="toast-text-message warning-toast">
    //     <div className="toast-title">Wrong file uploaded</div>
    //     <div className="toast-title-msg">
    //       {files.length} {files.length > 1 ? "files" : "files"} are discarded
    //       due to wrong Extension. Pl try again
    //     </div>
    //   </div>,
    //   {
    //     position: "top-right",
    //     autoClose: 5000000,
    //     icon: "",
    //     hideProgressBar: true,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: false,
    //     closeButton: (
    //       <img className="toast-success-close-icon" src={CloseIcon} />
    //     ),
    //     progress: undefined,
    //     className: "toast-popup toast-info-popup shared-toast-popup-wrong-file",
    //   }
    // );
  };

  return (
    <>
      {loading && (
        <CircularProgressBar isloading={loading} setIsloading={setLoading} />
      )}
      <div className={`shared-font-upload shared-font-upload-main`}>
        <div className="upload-thumb-image-main" style={{ paddingBottom: 0 }}>
          <div className="upload-thumb-image-content">
            <div className="d-flex divAlignment">
              <h3 className="chooseFile">
                Font Upload
              </h3>
                          
                          <CustomTooltip
                  classes="info-tooltip"
                  title="Add one or more fonts. Max 10 files can be uploaded together"
                  arrow
                >
                  <img src={InfoIcon} alt="" className="upload-thumb-info-icon" />
                </CustomTooltip>
            </div>

            {/*  */}
            {filesSelected?.length > 0  && <Dropzone
              ref={dropzoneRef}
              multiple={true}
              //maxFiles={10}
              accept="image/png"
              onDrop={(accepted, rejected) =>
                onFileSelection(accepted, rejected)
              }
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} className="add-thumb-Image">
                  <input {...getInputProps()} />
                  <img src={Addmore} style={{ marginRight: "13px" }} />{" "}
                  <span>ADD</span>{" "}
                </div>
              )}
            </Dropzone>}
            {/*  */}
          </div>
        </div>
        {filesSelected?.length > 0 ? (
          <div className="uploadedFont-block">
            <div className="all-fonts">
              {filesSelected?.map((file) => (
                <div className="font-details">
                  <div className="fileList">
                    <div className="font-name-block" title={file.name}>
                      <img
                        src={fontIcon}
                        alt=""
                        style={{ marginRight: "6px" }}
                      />
                      <div className="fontName">{file.name}</div>
                    </div>
                          <img
                              className="deleteIcon-class"
                      src={removeFontIcon}
                      alt=""
                      style={{
                        display: removeWarn === file.name ? "none" : "block",
                      }}
                      onClick={() => handleRemove(file.name)}
                    />
                  </div>
                  <div
                    className="delete-font-block"
                    style={{
                      display: removeWarn === file.name ? "block" : "none",
                    }}
                  >
                    <div className="warnMsg">
                      The image to be deleted might have been used in slides.{" "}
                      <span>Are you sure?</span>
                    </div>
                    <div className="confirm-block">
                      <div
                        className="optionNo"
                        onClick={() => confirmAction("NO", file)}
                      >
                        NO
                      </div>
                      <div
                        className="deleteFont"
                        onClick={() => confirmAction("YES", file)}
                      >
                        YES, DELETE
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div
            className={` uploadShared-UI ${
              filesSelected?.length > 0 ? "" : "borderAround"
            }`}
          >
            <div className="upload-thumb-image-main" style={{ paddingTop: 0 }}>
              <Dropzone
                ref={dropzoneRef}
                multiple={true}
                //maxFiles={10}
                accept="image/png"
                onDrop={(accepted, rejected) =>
                  onFileSelection(accepted, rejected)
                }
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()} className="upload-file-section">
                    <input {...getInputProps()} />
                    <img
                      src={SharedThumbImage}
                      width="12px"
                      height="12px"
                      className="upload-thumb-icon"
                    />
                    <span>ADD FONT FILE</span>
                  </div>
                )}
              </Dropzone>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SharedFontUpload;
